import { render, staticRenderFns } from "./caijixiangqing.vue?vue&type=template&id=7145a15c&scoped=true"
import script from "./caijixiangqing.vue?vue&type=script&lang=js"
export * from "./caijixiangqing.vue?vue&type=script&lang=js"
import style0 from "./caijixiangqing.vue?vue&type=style&index=0&id=7145a15c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7145a15c",
  null
  
)

export default component.exports